<ion-item color="{{ color }}">
    <ion-grid>
        <ion-row>
            <ion-badge color="{{ ColorClass.Primary }}" *ngIf="label !== undefined">{{
                label
            }}</ion-badge>
        </ion-row>
        <ion-row>
            <ion-col size="3" class="ion-align-self-start">
                <img [src]="orderItem.itemThumbnailSrc" />
            </ion-col>
            <ion-col size="9" class="ion-align-self-start">
                <ion-label class="ion-text-wrap">
                    <ion-row>
                        <ion-col>
                            <h2>{{ orderItem.orderItemName }}</h2>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="8.5">
                            <ion-label>
                                <strong>{{ 'common.sku' | translate }}:</strong>
                                {{ orderItem.sku || '-' }}
                            </ion-label>
                            <ion-label>
                                <strong>{{ 'common.price' | translate }}:</strong>
                                {{ orderItem.price | priceround }}
                                {{ 'common.currency' | translate }}
                            </ion-label>
                        </ion-col>
                        <ion-col
                            size="3.5"
                            *ngIf="orderItem.orderReplacementItem === null"
                        >
                            <app-order-item-state
                                [orderItemState]="orderItem.state"
                            ></app-order-item-state>
                        </ion-col>
                    </ion-row>
                </ion-label>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="ion-align-self-start">
                <p class="ion-no-margin">
                    <strong>{{ 'collecting.original' | translate }}: </strong>
                    {{ orderItem.orderedQuantity | decimal }}
                </p>
            </ion-col>
            <ion-col
                class="ion-align-self-center"
                *ngIf="orderItem.orderReplacementItem === null"
            >
                <p class="ion-no-margin">
                    <strong>{{ 'collecting.collected' | translate }}: </strong>
                    {{ orderItem.collectedQuantity | decimal }}
                </p>
            </ion-col>
            <ion-col
                class="ion-align-self-end"
                *ngIf="orderItem.orderReplacementItem === null"
            >
                <p class="ion-no-margin">
                    <strong>{{ 'collecting.approved' | translate }}: </strong>
                    {{ quantity | decimal }}
                </p>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col
                *ngFor="
                    let orderItemDepositProduct of orderItem.orderItemDepositProductList
                "
                class="border my-1"
            >
                <strong
                    >{{
                        'collecting.optional-deposit-quantity-title' | translate
                    }}:</strong
                ><br />
                {{ orderItemDepositProduct.depositUnitTypeName }}
                {{ orderItemDepositProduct.price | priceround }}
                {{ 'common.currency' | translate }}
                {{ orderItemDepositProduct.unitName }}
                <br />
                <div>
                    <strong>{{ 'collecting.quantity' | translate }}</strong
                    ><br />
                    {{ orderItemDepositProduct.unitValue }}
                    {{ 'collecting.piece(s)' | translate }}*
                    {{ orderItemDepositProduct.price | priceround }}
                    {{ 'common.currency' | translate }} =
                    <strong>
                        {{
                            orderItemDepositProduct.unitValue *
                                orderItemDepositProduct.price | priceround
                        }}
                        {{ 'common.currency' | translate }}</strong
                    >
                </div>

                <div *ngIf="orderItemDepositProduct.collectedQuantity">
                    <strong>{{ 'collecting.already-added-to-cart' | translate }}</strong
                    ><br />
                    {{ orderItemDepositProduct.collectedQuantity }}
                    {{ 'collecting.piece(s)' | translate }}*
                    {{ orderItemDepositProduct.price | priceround }}
                    {{ 'common.currency' | translate }} =
                    <strong>
                        <u
                            >+
                            {{
                                orderItemDepositProduct.collectedQuantity *
                                    orderItemDepositProduct.price | priceround
                            }}
                            {{ 'common.currency' | translate }}</u
                        ></strong
                    >
                </div>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-item>
